import moment from 'moment'
import {dateTimeFormat} from '../settings'

export default function (element, binding, vnode) {
  if (!binding.value.isIso) {
    binding.value.date = binding.value.date.replace(' ', 'T') + 'Z'
  }
  let time = moment(binding.value.date)

  if (binding.value.timeAgo) {
    time = time.fromNow()
  } else {
    time = time.format(binding.value.format || dateTimeFormat)
  }

  element.innerHTML = (binding.value.prefix || '') + ' ' + time
}
